export default{
  roles: (state) => state.roles,
  role: (state) => state.role
}



// WEBPACK FOOTER //
// ./src/components/role/store/getters.js